/*
 * The flag after a non-US tournament's title (decision 776): the Upcoming
 * summary's list and Past's collapsed band. Nothing for a US tournament or one
 * with no country.
 *
 * The emoji is named for assistive technology the way FencerSearch's is: a
 * role="img" span whose label and tooltip are the country's name in the
 * viewer's language (Intl.DisplayNames), so no catalogue carries a country.
 */

import { useTranslation } from "react-i18next";

import { countryName, flagEmoji, isAbroad } from "../lib/country";
import { dateLocale } from "../lib/format";
import styles from "./TournamentFlag.module.css";

export function TournamentFlag({ country }: { country?: string | null | undefined }) {
  // Subscribed for the re-render a language change brings; the name itself is
  // in the catalogue's Intl locale, as every date is (Serbian is "sr-Latn",
  // where the bare code would name countries in Cyrillic).
  useTranslation();
  if (!isAbroad(country)) return null;
  const flag = flagEmoji(country);
  if (!flag) return null;
  const name = countryName(country, dateLocale());
  return (
    <span className={styles.flag} role="img" aria-label={name} title={name}>
      {flag}
    </span>
  );
}
